import ContractStore from '../stores/ContractStore'

export async function getOraclePeriodLength() {
    let oraclePeriod;
    oraclePeriod = await ContractStore.call("Admin", "getOraclePeriod", []);
    return oraclePeriod;
}


export async function getMinOracleStake() {
    let oracleStake;
    oracleStake = await ContractStore.call("Admin", "getMinOracleStake", []);
    return oracleStake;
}



// WEBPACK FOOTER //
// ./src/contract/Admin.js